/* global MiniModal */
(($, MiniModal, once) => {
  Drupal.behaviors.dashboardDopDialog = {
    attach: (response, settings) => {
      // Close button.

      jQuery('.use-ajax, .hamburger-menu').on('click', function () {
        window.scrollTo(0, 0);
        if (!$(this).hasClass('hamburger-menu')) {
          $('.header').addClass('blur');
        }
        $('.layout-title').addClass('blur');
        $('.layout-content').addClass('blur');
      });

      jQuery(once('close-dop-dialog', '#dop-dialog [data-minimodal-close], .mobile-menu-close', response)).each(
        function () {
          $(this).on('click', function () {
            $('.header').removeClass('blur');
            $('.layout-title').removeClass('blur');
            $('.layout-content').removeClass('blur');
            if (!$(this).hasClass('.mobile-menu-close')) {
              MiniModal.close('dop-dialog');
            }
          });
        },
      );

      jQuery('#login-form-button a').on('click', () => {
        MiniModal.close('dop-dialog');
      });
    },
  };
})(jQuery, MiniModal, once);
